import { render, staticRenderFns } from "./game-list.vue?vue&type=template&id=b0d75ca2&scoped=true&"
import script from "./game-list.vue?vue&type=script&lang=js&"
export * from "./game-list.vue?vue&type=script&lang=js&"
import style0 from "./game-list.vue?vue&type=style&index=0&id=b0d75ca2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d75ca2",
  null
  
)

export default component.exports